import { render, staticRenderFns } from "./APGTest.vue?vue&type=template&id=1cccbd54"
import script from "./APGTest.vue?vue&type=script&lang=js"
export * from "./APGTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports